<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jX0Elt/tc-custom/9780805099720.jpg?1737749006220" alt="This image is the cover for the book Tales of Bunjitsu Bunny"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tales of Bunjitsu Bunny
      </h1>
      <p class="bookDescription body article font2">
        <b>This children’s series debut introduces a martial arts-loving bunny who “delivers a series of Zen lessons touched with gentle humor” (<i>Kirkus Reviews</i>).</b><br/><br/>Meet Isabel, aka Bunjitsu Bunny! She is the BEST bunjitsu artist in her school, and she can throw farther, kick higher, and hit harder than anyone else. But she never hurts another creature . . . unless she has to. This series of brief stories about Isabel’s adventures combine fun, child-friendly scenarios and Eastern wisdom perfect for the youngest readers.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Himmelman
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Henry Holt and Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?27b01616